import React from 'react';
// Loads user favorite info and keeps it in sync
// Defined in general.js
/* global setHeaderMMILink getFavList readCookie */
// Once searchControl is migrated to hooks, we could use this hook there

import { onSignInOutExecute } from '../onSignInOutExecute.js';
import { setup, load } from '../followList.js';


export const useFavorites = function () {
    const [favorites, setFavorites] = React.useState();
    const [donorGivingPages, setDonorGivingPages] = React.useState();
    const [followLists, setFollowLists] = React.useState();
    const [favoritesLoaded, setFavoritesLoaded] = React.useState(false);
    const [searchesLoaded, setSearchesLoaded] = React.useState(false);

    const loadSavedSearches = React.useCallback(function (isMore) {
        load(
            isMore && followLists.searches,
            data => {
                if (isMore) {
                    // Add new searches to a copy of the current followList data
                    const newSearches = followLists.searches.concat(data.searches);
                    data = Object.assign({}, followLists, {
                        moreSearches: data.moreSearches,
                        searches: newSearches,
                    });
                }

                setFollowLists(data);
                setSearchesLoaded(true);
            },
        );
    }, [followLists]);

    React.useEffect(() => {
        function loadFavorites() {
            $.when(getFavList('favProposalIds'), getFavList('favTeacherIds'), getFavList('favSchoolIds'), getFavList('favSearchURLs'), getFavList('myGPs')).then(
                (favProposalIds, favTeacherIds, favSchoolIds, favSearchHashes, myGPs) => {
                    setFavorites({
                        projectIds: favProposalIds,
                        teacherIds: favTeacherIds,
                        schoolIds: favSchoolIds,
                        searchHashes: favSearchHashes,
                    });
                    setDonorGivingPages(myGPs);

                    // Sometimes favorites can get set as empty lists before getting filled out because we're
                    // still loading them. That could make use incorrectly think the user doesn't have favorites.
                    // Once this cookie exists, it indicates the favorites are truly loaded.
                    // (see addFavoritesToLocalStorage in favorites.js for related code)
                    if (readCookie('favCookiesSet')) {
                        setFavoritesLoaded(true);
                    }
                },
            );

            // Update headers based on some favorites cookies
            setHeaderMMILink();
            loadSavedSearches(false);
        }

        const cancelSetup = setup(loadFavorites);
        const cancelReload = onSignInOutExecute(loadFavorites);

        return () => {
            cancelSetup && cancelSetup();
            cancelReload();
        };
        // We don't include loadFollowList as a dep here because we only want to use it on initial load
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { favorites, donorGivingPages, savedSearches: followLists && followLists.searches, loadSavedSearches, favoritesLoaded, searchesLoaded };
};
